// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e0045c8","946":"6fa7787f"}[chunkId] + ".chunk.js";
};